function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.top <= window.innerHeight;
}

function updateActiveTag() {
  const goToTags = document.querySelectorAll('.js-go-to-tag');
  const headings = document.querySelectorAll(
    '.js-page-content h1:not([class]), ' +
    '.js-page-content h2:not([class]), ' +
    '.js-page-content h3:not([class]), ' +
    '.js-page-content h4:not([class]), ' +
    '.js-page-content h5:not([class]), ' +
    '.js-page-content h6:not([class])'
  );

  let activeFound = false;

  for (let i = 0; i < headings.length; i++) {
    const heading = headings[i];
    if (isElementInViewport(heading)) {
      const index = i + 1; // bo liczymy od 1
      goToTags.forEach(tag => {
        if (parseInt(tag.getAttribute('data-index'), 10) === index) {
          tag.classList.add('active');
        } else {
          tag.classList.remove('active');
        }
      });
      activeFound = true;
      break;
    }
  }

  if (!activeFound) {
    goToTags.forEach(tag => tag.classList.remove('active'));
  }
}

window.addEventListener('scroll', updateActiveTag);
window.addEventListener('resize', updateActiveTag);
document.addEventListener('DOMContentLoaded', updateActiveTag);

document.querySelectorAll('.js-go-to-tag').forEach(tag => {
  tag.addEventListener('click', function (e) {
    e.preventDefault();

    const index = parseInt(this.getAttribute('data-index'), 10);
    const headings = document.querySelectorAll(
      '.js-page-content h1:not([class]), ' +
      '.js-page-content h2:not([class]), ' +
      '.js-page-content h3:not([class]), ' +
      '.js-page-content h4:not([class]), ' +
      '.js-page-content h5:not([class]), ' +
      '.js-page-content h6:not([class])'
    );

    const targetHeading = headings[index - 1];
    if (targetHeading) {
      const offset = 110;
      const scrollPosition = window.scrollY + targetHeading.getBoundingClientRect().top - offset;

      window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth'
      });
    }
  });
});